// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"05b2b50a","498":"e0378c3c","659":"d696c1ff","703":"5a86b4ce"}[chunkId] + ".chunk.js";
};